import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { ProductProps } from 'utils/types';

export const fileKey = ['productFinder'];

interface Props {
  type: string;
}

const useFileProductFinder = ({ type }: Props) => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient()(`file-data/calc?dataType=${type}`).then(
    (response) => {
      const result: ProductProps[] = [];
      response?.data?.data?.forEach((element: any) => {
        result.push({
          ['Plant ID']: element?.['0'],
          ['Plant City']: element?.['1'],
          ['Plant']: element?.['2'],
          ['Brand ID']: element?.['3'],
          ['Brand']: element?.['4'],
          ['Product ID']: element?.['5'],
          ['GIN Index']: element?.['6'],
          ['Product Name']: element?.['7'],
          ['Application']: element?.['8'],
          ['Packaging']: element?.['9'],
          ['Prod.Class-Text ?']: element?.['10'],
          ['Particle Size↵in um']: element?.['11'],
          ['PIS ID']: element?.['12'],
          ['PIS in the folder']: element?.['13'],
        });
      });

      return result as ProductProps[];
    },
  ),
});

export default useFileProductFinder;
